import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';

@Component({
    selector: 'cp-pending-change-orders',
    templateUrl: './pending-change-orders.component.html',
    styleUrls: ['./pending-change-orders.component.scss'],
    standalone: false
})
export class PendingChangeOrdersComponent{

    constructor() { }

    @Input() chartType: string = 'donut';
    @Input() inputSearchParams: WidgetSearch;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    widgetQuery: DashboardQueries = DashboardQueries.pendingChangeOrders;
    chartSearchFilters: widgetFilters[] = [widgetFilters.customer,
        widgetFilters.class,
        widgetFilters.projectManager,
        widgetFilters.status,
        widgetFilters.contAdmin,
        widgetFilters.divisions];

    changeLoader(e) {
        this.loaderState.emit(e);
    }

    changeErrorLoader(e) {
        this.loaderErrorState.emit(e);
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }

}
